import { render } from "./jyUploader.vue?vue&type=template&id=8a119aac&scoped=true"
import script from "./jyUploader.vue?vue&type=script&lang=js"
export * from "./jyUploader.vue?vue&type=script&lang=js"

import "./jyUploader.vue?vue&type=style&index=0&id=8a119aac&lang=less&scoped=true"

import exportComponent from "/Users/yiduolanghua/Desktop/edu/visitor-h5-jy/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a119aac"]])

export default __exports__